import React from 'react'
import { GlobalStyles as MuiGlobalStyles } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { HIGHLIGHTER_CURSOR, ERASER_CURSOR } from './constants'

const HighlightGlobalStyles: React.FC = () => {
  const theme = useTheme()

  return (
    <MuiGlobalStyles
      styles={{
        // Styles for highlight
        'span.highlight': {
          backgroundColor: theme.palette.amber[100],
          color: 'inherit',
          padding: 0,
        },
        // Cursor for highlight mode
        '.highlight-mode, .highlight-mode *': {
          cursor: `url('${HIGHLIGHTER_CURSOR}') 4 24, crosshair !important`,
        },
        // Cursor for erase mode
        '.erase-mode, .erase-mode *': {
          cursor: `url('${ERASER_CURSOR}') 4 24, not-allowed !important`,
        },
        '.erase-mode span.highlight': {
          transition: 'opacity 0.2s',
          '&:hover': {
            opacity: 0.85,
          },
          // a11y: erase mode makes each highlight a focusable button (role="button"); show a keyboard
          // focus ring so a keyboard user can see which highlight Enter/Space will remove (SC 2.4.7).
          '&:focus-visible': {
            outline: `3px solid ${theme.palette.additionalColors.focus_blue}`,
            outlineOffset: 2,
          },
        },
      }}
    />
  )
}

export default HighlightGlobalStyles
